export default function mask() {
    if (document.querySelector("#phone")) {
        $("#phone").mask("(00) 00000-0000");
    }
    
    if (document.querySelector("#cnpj")) {
        $("#cnpj").mask("00.000.000/0000-00") ;
    }
}